<template>
  <div id="app">
    <keep-alive v-if="$route.meta.keepAlive">
      <router-view />
    </keep-alive>
    <router-view v-else />
    <el-backtop v-if="showBackTop && !isMobileScreen"> </el-backtop>
  </div>
</template>
<script>
export default {
  name: "app",
  watch: {
    dataTheme: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          document.body.setAttribute("data-theme", newVal);
        }
      },
    },
  },
  computed: {
    dataTheme() {
      return this.$store.getters.dataTheme;
    },
    screenWidth() {
      return this.$store.getters.screenWidth;
    },
    screenHeight() {
      return this.$store.getters.screenHeight;
    },
    isMobileScreen() {
      return this.$store.getters.isMobileScreen;
    },
    showBackTop() {
      return this.$store.getters.showBackTop;
    },
  },
  created() {
    this.$store.dispatch("setting/setDataTheme", "dark");
    this.$store.dispatch("setting/setCollapse", false);
  },
  methods: {
    // 获取屏幕尺寸，写入store，供所有组件调用
    autoSize: function () {
      let width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
      let height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
      // console.log(`width => ${width}`)
      // console.log(`height => ${height}`)
      // if (width < 830) {
      //   document.getElementsByTagName('html')[0].style.fontSize = '16px'
      // } else {
      //   document.getElementsByTagName('html')[0].style.fontSize = '20px'
      // }
      // if (this.$config.isIe && this.$config.isIe9) {
      //   // 是IE9浏览器，则直接限制死窗口尺寸，不使其进入移动端组件
      //   if (width <= 768) {
      //     console.log(`in <= 768`)
      //     // window.resizeTo(800, 600)
      //     console.log(`resize over`)
      //     document.getElementById('app').style.display = 'none'
      //     alert(`窗口尺寸过小不利于浏览网页，请设置窗口为768px以上尺寸进行浏览`)
      //   } else {
      //     document.getElementById('app').style.display = 'block'
      //   }
      // }
      // 提交Store保存
      this.$store.commit('setting/SET_WIDTH', width)
      this.$store.commit('setting/SET_HEIGHT', height)
    },
    // 绑定屏幕尺寸的调整的事件
    bindAutoSetScreenSize: function () {
      // console.log(this.$config)
      // 绑定窗口大小修改事件，以获得窗口改变之后的宽度值
      this.autoSize()
      const that = this
      // 监听浏览器窗口大小改变
      window.addEventListener('resize', function () {
        // that.screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
        // that.screenHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight
        that.autoSize()
      }, false)
    },
    // 获取设置数据
    async settings() {
      const res = await this.$api.settings()
      this.$store.commit('setting/SET_SETTINGS', res)
    },
    // 初始化动作
    initData: function () {
      this.bindAutoSetScreenSize()
      this.settings()
    }
  },
  mounted () {
    this.initData()
  }
};
</script>
<style lang="scss">
.el-backtop {
  color: #e1242a !important;
}

#app {
  font-family: MuseoSans300, 苹方-简, "PingFang", "PingFangSC Medium", "PingFangSC", 思源黑体, "Microsoft YaHei", 微软雅黑, "Microsoft JhengHei", "SimHei";
  /* font-family: MuseoSans300, PingFang-TC-Medium, PingFangZH-Medium, 苹方, 苹方-简, "PingFang", "PingFangSC Medium", "PingFangSC", 思源黑体, "Microsoft YaHei", 微软雅黑, "Microsoft JhengHei", "SimHei"; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* 取消双击文字或者输入框，选中文字的蓝色背景色 */
  /*双击文字、input等，出现的蓝色底色，如何去除*/
  -moz-user-select: none; /*火狐*/
  -webkit-user-select: none; /*webkit浏览器*/
  -ms-user-select: none; /*IE10*/
  /*-khtml-user-select:none;!*早期浏览器*!*/
  user-select: none;
  word-break: break-all; /* 强制单词在任意位置换行 */
  word-wrap: break-word; /* 处理长单词或无法使用断点的单词 */
}
</style>
